import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import Popup from '../../shared/popup/Popup'
import StatusItem from '../../shared/purchaseStatus/StatusItem'

const PurchaseStatusConfirmation = ({
  onSubmit,
  onCancel,
  isProcessing,
  ...restProps
}) => {
  const { t } = useTranslation()
  return (
    <Popup
      title={t('membership.status-upgrade-confirmation')}
      description={t('membership.status-upgrade-confirmation-desc')}
      submitLabel={t('membership.confirm-upgrade')}
      cancelLabel={t('common.cancel')}
      onFormSubmit={onSubmit}
      onCancel={onCancel}
      submitBtnProps={{
        loading: isProcessing
      }}
    >
      <StatusItem t={t} {...restProps} />
    </Popup>
  )
}

export default memo(PurchaseStatusConfirmation)
